import React from 'react';
import { Link } from 'react-router-dom';
import { Github, Twitter, Linkedin, Heart } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-white dark:bg-dark-card border-t border-reddit-200 dark:border-dark-border mt-12 lg:ml-64">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* About */}
          <div>
            <h3 className="text-lg font-semibold mb-3">About Trendy</h3>
            <p className="text-sm text-reddit-600 dark:text-dark-textMuted">
              Real-time trending topic analyzer that visualizes what's happening across the web.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-3">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/documentation" className="text-reddit-600 dark:text-dark-textMuted hover:text-reddit-orange transition-colors">
                  Documentation
                </Link>
              </li>
              <li>
                <Link to="/api-reference" className="text-reddit-600 dark:text-dark-textMuted hover:text-reddit-orange transition-colors">
                  API Reference
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="text-reddit-600 dark:text-dark-textMuted hover:text-reddit-orange transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-of-service" className="text-reddit-600 dark:text-dark-textMuted hover:text-reddit-orange transition-colors">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h3 className="text-lg font-semibold mb-3">Connect</h3>
            <div className="flex gap-4">
              <a
                href="#"
                className="p-2 rounded-full hover:bg-reddit-100 dark:hover:bg-dark-border transition-colors"
                aria-label="GitHub"
              >
                <Github className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="p-2 rounded-full hover:bg-reddit-100 dark:hover:bg-dark-border transition-colors"
                aria-label="Twitter"
              >
                <Twitter className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="p-2 rounded-full hover:bg-reddit-100 dark:hover:bg-dark-border transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-reddit-200 dark:border-dark-border">
          <p className="text-center text-sm text-reddit-600 dark:text-dark-textMuted flex items-center justify-center gap-1">
            Trendy © 2026
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;